// eslint-disable-next-line import/prefer-default-export
export const ONBOARDING = "/get-started";
